import React, { useContext, useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { AccountContext } from "../../contexts/AccountContext";
import ExportDropbox from "../Budget/ExportDropbox";
import LoadingScreen from "../LoadingScreen";
import { CONFIG } from "../../config";
import Container from "react-bootstrap/esm/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import BoQDetails from "./BoQDetails";

// Component to send the account data and get url parameters
export default function BoQ() {
    const { id } = useParams()
    const account = useContext(AccountContext); // Send to SimpleLinkComponent the user's token
    return <BoQComponent accountToken={account.token} linkId={id} />
}


export function BoQComponent(props) {

    const isLoading = useRef(false);

    const [linkBoQ, setBoQ] = useState({});

    const [linkName, setName] = useState("");
    
    // Get the link name
    fetch(CONFIG.apiURI+"/link/"+props.linkId, { 
        method: 'GET',
        mode: "cors",
        headers: {
            Accept: 'application/json',
            "token": props.accountToken
        }
        })
    .then((res) => res.json())
    .then((jsonLinkData) => { 
        setName(jsonLinkData.link.name);
    });


    // Get the boq data
    useEffect(() => {
        fetch(CONFIG.apiURI+"/link/"+props.linkId+"/boq", { 
        method: 'GET',
        mode: "cors",
        headers: {
            Accept: 'application/json',
            "token": props.accountToken
        }
        })
    .then((res) => res.json())
    .then((BoQData) => {
        setBoQ(BoQData)
        //setName(BoQData[0].linkName)
        isLoading.current = true;
    })
}, [])

    /**
     * Transform data to be placed in the data grid
     * @param linkBoQData
     * @returns an array (1D)
     */
    function serializeDataGrid(linkBoQData) {

        let res = [];
          
        if(linkBoQData !== null && linkBoQData !== undefined) {
            let jsonBoQData = linkBoQData;

            if (jsonBoQData.length === 0) return [];

            for (let i = 0; i < jsonBoQData.length; i++) {

                const line = {
                    partNumber: String,
                    productName: String,
                    Quantity: Number
    
                };

                const category = {
                    partNumber: String,
                    productName: String,
                    Quantity: Number
    
                };                
                
                if (i === 0) {
                    category.partNumber = jsonBoQData[i].exportCategory;                     
                    category.productName = "";
                    category.Quantity = null;                      
                    res.push(category);
                }

                if (i > 0) {
                    if (jsonBoQData[i].exportCategory !== jsonBoQData[i-1].exportCategory) {
                        category.partNumber = jsonBoQData[i].exportCategory;
                        category.productName = "";
                        category.Quantity = null;                        
                        res.push(category);
                    }
                }

                line.partNumber = jsonBoQData[i].partNumber;
                line.productName = jsonBoQData[i].productName;
                line.Quantity = jsonBoQData[i].quantity;
                res.push(line);
            }            
        }

        return res;
    }

 
    return (<>
        <LoadingScreen displayed={!isLoading.current} />
        <Container className="mt-3">
            <>
            <Row>
                <Col className="col-5">
                    <Button className="menu-button" bsPrefix="" variant="secondary" onClick={() => window.location.href = "/"}>My links</Button>
                    <Button className="menu-button ms-2" bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+props.linkId+""}>Link configuration</Button>
                    <Button className="menu-button ms-2" bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+props.linkId+"/budget"}>Link budget</Button>
                    <Button className="menu-button-active ms-2" bsPrefix="" variant="secondary">Link BoM</Button>
                </Col>
                <Col className="col-4">
                    <div><h5 className="h5 ps-4 pt-2">{linkName}</h5></div>
                </Col>
                <Col>
                    <ExportDropbox link={props.link} linkBoQ={linkBoQ} />
                </Col>
            </Row>

            <Row className="mt-3 d-flex d-lg-flex"> 
                <Col>
                    <BoQDetails data={serializeDataGrid(linkBoQ)}></BoQDetails>
                </Col>
            </Row>
            <br></br><br></br>
            <Row>
                <Col>
                    <div><p style={{textAlign: "center", fontSize: "12px", fontFamily: "NokiaFont"}}>{CONFIG.sentences["page.info.bom.warning"]}</p></div>
                </Col>
            </Row>
            </>            

        </Container>
    </>);
}
